// utils/getBrowserInfo.ts
export interface BrowserInfo {
  name: string
  version: string
  os?: string
  device?: string
}

export function getBrowserInfo(): BrowserInfo {
  if (import.meta.server) return null;
  if (typeof navigator === "undefined") {
    return { name: "Unknown", version: "0" }
  }

  const ua = navigator.userAgent.toLowerCase()
  const browser: BrowserInfo = { name: "Unknown", version: "0" }

  // OS / 设备识别
  if (/iphone|ipad|ipod/i.test(ua)) {
    browser.os = "iOS"
    browser.device = "iPhone/iPad"
  } else if (/android/i.test(ua)) {
    browser.os = "Android"
    browser.device = "Android"
  } else if (/macintosh|mac os x/i.test(ua)) {
    browser.os = "MacOS"
  } else if (/windows/i.test(ua)) {
    browser.os = "Windows"
  }

  // 浏览器识别
  if (/micromessenger/i.test(ua)) {
    browser.name = "WeChat"
    browser.version = ua.match(/micromessenger\/([\d.]+)/i)?.[1] || "0"
  } else if (/edg/i.test(ua)) {
    browser.name = "Edge"
    browser.version = ua.match(/edg\/([\d.]+)/i)?.[1] || "0"
  } else if (/chrome|crios|crmo/i.test(ua)) {
    browser.name = "Chrome"
    browser.version = ua.match(/(?:chrome|crios|crmo)\/([\d.]+)/i)?.[1] || "0"
  } else if (/firefox|fxios/i.test(ua)) {
    browser.name = "Firefox"
    browser.version = ua.match(/(?:firefox|fxios)\/([\d.]+)/i)?.[1] || "0"
  } else if (/safari/i.test(ua) && !/chrome|crios|crmo|edg|opr|fxios/i.test(ua)) {
    // 🚨 Safari 必须排除 Chrome/Edge/Opera/Firefox
    browser.name = "Safari"
    browser.version = ua.match(/version\/([\d.]+)/i)?.[1] || "0"
  } else if (/msie|trident/i.test(ua)) {
    browser.name = "IE"
    browser.version = ua.match(/(?:msie |rv:)([\d.]+)/i)?.[1] || "0"
  }

  return browser
}
